import StatsCard from './StatsCard';

export default StatsCard;